import React from 'react'

import {
  ProgramCardContainer,
  CardIcon,
  Footer,
  CardContent,
  ProgramTimings,
  ProgramName,
  EnrolLink,
  EnrolText
} from './styles'

const ProgramCard = ({ card, onCardClick }) => {
  const { name, timings, standardsShortCodesDisplay, uuid, image } = card
  return (
    <ProgramCardContainer key={uuid} onClick={onCardClick}>
      <EnrolLink>
        <EnrolText>Enrol</EnrolText>
        <span className="fc-icon fc-icon-chevron-right"></span>
      </EnrolLink>
      <CardContent>
        {image && <CardIcon src={image} alt={name} />}
        <ProgramTimings>{timings}</ProgramTimings>
        <ProgramName>{name}</ProgramName>
      </CardContent>
      <Footer>{standardsShortCodesDisplay}</Footer>
    </ProgramCardContainer>
  )
}

export { ProgramCard }
